
































































































import { Element, StructureError } from '@/models'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { BaseTree } from '@he-tree/vue/vue2'
import { Utils } from '@/utils'
import { Stat } from '@he-tree/tree-utils'

@Component({
  components: {
    BaseTree
  }
})
export default class StructureInfoElementModal extends Vue {
  @Prop({ required: true }) element: Element
  @Prop({ required: false, type: Array, default: () => [] }) errors: StructureError[]

  hideModal() {
    this.$bvModal.hide('structureInfoElementModal')
  }

  get errorsByElementId(): Map<string, StructureError[]> {
    const map = new Map<string, StructureError[]>()
    this.errors.forEach((error: StructureError) => {
      if (!map.has(error.elementId)) {
        map.set(error.elementId, [])
      }
      const elementErrors = map.get(error.elementId)
      if (elementErrors) {
        elementErrors.push(error)
      }
    })
    return map
  }

  private getElementErrors(node: Element): StructureError[] {
    return this.errorsByElementId.get(node.id) || []
  }

  private getElementErrorsTitle(node: Element): string {
    const labels = this.getElementErrors(node).map((error: StructureError) => this.$t('structure_errors_modal.types.' + error.type) as string)
    return [...new Set(labels)].join(', ')
  }

  get isAdmin(): boolean {
    return this.$store.getters.isAdmin
  }

  private getElementTypeName(codeId: string) {
    return Utils.findElementTypeName(codeId, this.$store.getters.elementTypes)
  }

  private toggleExpand(stat: Stat<Element>) {
    stat.open = !stat.open
  }
}
